import React, { ReactNode } from 'react';
import { GenericPopup } from './GenericPopup';
import { SignaturePage } from './SignaturePage';
import '../../scss/controls/_genericPopup.scss';

export const SignaturePopup: React.FC<{
    id: string;
    isOpen: boolean;
    children: ReactNode;
    title?: string;
    showTitle?: boolean;
    width?: string;
    height?: string;
    minHeight?: string;
    maxWidth?: string;
    maxHeight?: string;
    onSubmitAgreement: () => void;
    onDeclineAgreement: () => void;
    hideOnOutsideClick?: boolean;
    firstName: string;
    lastName: string;
}> = ({
    id,
    isOpen,
    children,
    title,
    width = 'auto',
    height = 'auto',
    minHeight = 'auto',
    maxWidth = 'auto',
    maxHeight,
    onSubmitAgreement,
    onDeclineAgreement,
    hideOnOutsideClick = false,
    firstName,
    lastName,
}) => {
    return (
        <>
            <GenericPopup
                id={id}
                isOpen={isOpen}
                showTitle={false}
                width={width}
                height={height}
                minHeight={minHeight}
                maxWidth={maxWidth}
                maxHeight={maxHeight}
                hideOnOutsideClick={hideOnOutsideClick}
            >
                <SignaturePage
                    agreementHeader={title}
                    agreementBody={children}
                    onSubmitAgreement={onSubmitAgreement}
                    onDeclineAgreement={onDeclineAgreement}
                    maxWidth={maxWidth}
                    firstName={firstName}
                    lastName={lastName}
                />
            </GenericPopup>
        </>
    );
};
